var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2543 35.5207C69.2543 54.6447 53.7512 70.1478 34.6271 70.1478C15.5031 70.1478 0 54.6447 0 35.5207C0 16.3967 15.5031 0.893555 34.6271 0.893555C53.7512 0.893555 69.2543 16.3967 69.2543 35.5207Z",
    fill: "#2A5ADA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5441_6966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6263 17.4209L31.2952 19.3306L22.2179 24.5615L18.8867 26.4712V44.5717L22.2179 46.4814L31.3785 51.7123L34.7096 53.622L38.0407 51.7123L47.0348 46.4814L50.3659 44.5717V26.4712L47.0348 24.5615L37.9575 19.3306L34.6263 17.4209ZM25.549 40.7523V30.2906L34.6263 25.0597L43.7037 30.2906V40.7523L34.6263 45.9832L25.549 40.7523Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5441_6966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.4792,
    height: 36.2011,
    fill: "white",
    transform: "translate(18.8867 17.4209)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.e424e164eae8eb0a8287495592837acb.svg";
export { ForwardRef as ReactComponent };